import React from 'react';
import useFeatureToggleService from 'feature-toggle';
import { TooltipIconLayoutProps } from '../types';
import ShadcnTooltipIconLayout from './ShadcnTooltipIconLayout';
import LegacyTooltipIconLayout from './LegacyTooltipIconLayout';

export default function TooltipIconLayoutWeb(
  props: TooltipIconLayoutProps
) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnTooltipIconLayout {...props} />;
  } else {
    return <LegacyTooltipIconLayout {...props} />;
  }
}
